
import $ from "jquery"
import "chosen-jquery"


import I18n from "plugins/i18n-js"


const text_option = {
  placeholder_text_multiple:  I18n.t("js.jquery_chosen.labels.default_multiple_text"),
  placeholder_text_single:    I18n.t("js.jquery_chosen.labels.default_single_text"),
  no_results_text:            I18n.t("js.jquery_chosen.labels.default_no_result_text"),
}

const old_chosen = (($.fn as any).chosen as ((options: object) => any));
($.fn as any).chosen = function(options: object){
  const new_options = Object.assign({}, text_option, options)
  old_chosen.call(this, new_options)
}



